import {
    SET_LOCATION,
    SET_LOCATION_PRESENT,
    DETECT_LOCATION_REQUEST,
    DETECT_LOCATION_SUCCESS,
    DETECT_LOCATION_FAILURE,
    GET_LIVE_LOCATION_REQUEST,
    GET_LIVE_LOCATION_SUCCESS,
    GET_LIVE_LOCATION_FAILURE,
} from "../../actions/location/locationActionTypes";

const initialState = {
    location: null,
    city: null,
    area: null,
    isLocationPresent: false,
    isDetecting: false,
    error: null,
    coordinates: null,
};

const locationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOCATION:
            return {
                ...state,
                location: action.payload.location,
                city: action.payload.city,
                area: action.payload.area,
                coordinates: action.payload.coordinates || state.coordinates,
                isLocationPresent: true,
                error: null,
            };

        case SET_LOCATION_PRESENT:
            return {
                ...state,
                isLocationPresent: action.payload,
            };

        case DETECT_LOCATION_REQUEST:
            return {
                ...state,
                isDetecting: true,
                error: null,
            };

        case DETECT_LOCATION_SUCCESS:
            return {
                ...state,
                location: action.payload.location,
                city: action.payload.city,
                area: action.payload.area,
                coordinates: action.payload.coordinates,
                isLocationPresent: true,
                isDetecting: false,
                error: null,
            };

        case DETECT_LOCATION_FAILURE:
            return {
                ...state,
                isDetecting: false,
                error: action.payload,
            };

        case GET_LIVE_LOCATION_REQUEST:
            return { ...state, isDetecting: true, error: null };

        case GET_LIVE_LOCATION_SUCCESS:
            return {
                ...state,
                location: action.payload.location,
                city: action.payload.city,
                area: action.payload.area,
                coordinates: action.payload.coordinates,
                isLocationPresent: true,
                isDetecting: false,
                error: null,
            };

        case GET_LIVE_LOCATION_FAILURE:
            return { ...state, isDetecting: false };

        default:
            return state;
    }
};

export default locationReducer;
